import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import { useTranslation } from '../../../../../../modules/translation/TranslationContext';
import { ColumnsVisibilityConfigItem } from '../../columnsVisibility.types';
interface ColumnsVisibilityConfigProps {
  configs?: ColumnsVisibilityConfigItem[];
}

const ColumnsVisibilityConfig = ({ configs }: ColumnsVisibilityConfigProps) => {
  const { translate } = useTranslation();

  if (!configs?.length) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 / 2, padding: 3 / 2 }}>
      {configs.map((config) => (
        <Box
          key={config.id}
          sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}
        >
          <Typography sx={(theme) => ({ color: theme.palette.text.secondary })}>
            {translate(config.label)}
          </Typography>
          {config.renderControl({ value: config.value, onChange: config.onApply })}
        </Box>
      ))}
    </Box>
  );
};

export default ColumnsVisibilityConfig;
